const state = {
  userName: '',
  userStatus: ''
};
const mutations = {
  SET_USER_NAME(state, name) {
    state.userName = name;
  },
  SET_USER_STATUS(state, name) {
    state.userStatus = name;
  }
};
const actions = {
  // 设置name
  setUserName({
    commit
  }, name) {
    commit('SET_USER_NAME', name);
  },
  setUserStatus({
    commit
  }, status) {
    commit('SET_USER_STATUS', status);
  }
};
export default {
  state,
  mutations,
  actions
};